import classNames from 'classnames';
import classes from './PersonSearchMode.module.scss';

export type PersonSearchModeValue = 'name' | 'phone';

interface PersonSearchModeProps {
    mode: PersonSearchModeValue;
    onChange: (mode: PersonSearchModeValue) => void;
    disabled?: boolean;
    compact?: boolean;
}

/** Переключает поиск человека между именем и телефоном. */
export const PersonSearchMode = (
    { mode, onChange, disabled = false, compact = false }: PersonSearchModeProps
) => (
    <div
        className={classNames(classes.menu, compact && classes.compact)}
        role="group"
        aria-label="Способ поиска"
    >
        <button
            type="button"
            className={classes.option}
            aria-pressed={mode === 'name'}
            onClick={() => onChange('name')}
            disabled={disabled}
        >
            {compact
                ? 'Имя'
                : 'По имени'}
        </button>
        <button
            type="button"
            className={classes.option}
            aria-pressed={mode === 'phone'}
            onClick={() => onChange('phone')}
            disabled={disabled}
        >
            {compact
                ? 'Телефон'
                : 'По телефону'}
        </button>
    </div>
);
